var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(-288 -2075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 40,
    height: 40,
    transform: "translate(288 2075)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "quality_1_",
    "data-name": "quality (1)",
    transform: "translate(293.233 2080.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M98.515,91.06a7.273,7.273,0,1,0,7.477,7.27A7.384,7.384,0,0,0,98.515,91.06Zm0,13.218a5.95,5.95,0,1,1,6.118-5.948A6.042,6.042,0,0,1,98.515,104.278Z",
    transform: "translate(-83.748 -83.404)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M171.338,196.22l-2.726,2.906-1.7-1.808a.493.493,0,0,0-.728,0,.575.575,0,0,0,0,.776l2.06,2.2a.493.493,0,0,0,.728,0l3.09-3.294a.575.575,0,0,0,0-.776A.493.493,0,0,0,171.338,196.22Z",
    transform: "translate(-154.187 -182.919)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M28.3,8.8,25.274,6.968,24.6,4.133a2.587,2.587,0,0,0-2.723-2l-3.44.269L16.449.632a2.564,2.564,0,0,0-3.366,0L11.1,2.4l-3.44-.269A2.586,2.586,0,0,0,4.943,4.1L4,7.139,1.239,8.8A2.626,2.626,0,0,0,.2,12.031l1.177,2.882L.2,17.8a2.626,2.626,0,0,0,1.04,3.235l3.016,1.816.68,2.847A2.589,2.589,0,0,0,7.453,27.7c.182,0-.022.007,3.609-.274l2.021,1.792a2.564,2.564,0,0,0,3.366,0l2.021-1.792,3.4.266a2.588,2.588,0,0,0,2.723-2l.678-2.836c3.694-2.234,2.91-1.758,3.021-1.828a2.626,2.626,0,0,0,1.04-3.235l-1.177-2.882,1.177-2.882A2.626,2.626,0,0,0,28.3,8.8Zm-1.872,6.45,1.313,3.216a.875.875,0,0,1-.343,1.076l-3.319,2.008a.873.873,0,0,0-.4.545l-.763,3.192a.862.862,0,0,1-.908.666l-3.767-.295a.86.86,0,0,0-.637.215l-2.28,2.022a.854.854,0,0,1-1.114,0l-2.28-2.022a.859.859,0,0,0-.637-.215l-3.767.295a.862.862,0,0,1-.908-.666l-.766-3.2a.874.874,0,0,0-.4-.546L2.141,19.538A.875.875,0,0,1,1.8,18.462l1.313-3.216a.882.882,0,0,0,0-.667L1.8,11.364a.875.875,0,0,1,.342-1.075L5.168,8.471a.873.873,0,0,0,.384-.49C6.667,4.386,6.6,4.6,6.617,4.543a.861.861,0,0,1,.908-.666l3.8.3a.859.859,0,0,0,.639-.216l2.242-2a.854.854,0,0,1,1.112,0l2.242,2a.86.86,0,0,0,.639.216l3.8-.3a.863.863,0,0,1,.908.666l.763,3.192a.874.874,0,0,0,.4.545l3.319,2.008a.875.875,0,0,1,.343,1.076l-1.313,3.216a.883.883,0,0,0,0,.667Z",
    transform: "translate(0)",
    fill: "#4A4A4A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.9edf127937ef22d29f80aba4478b0362.svg";
export { ForwardRef as ReactComponent };